import axios from 'axios'
import { Message } from 'element-ui'
import base from './base'

const baseURL = base.url
const req = axios.create({
  baseURL: baseURL,
  timeout: 300000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  },
  // 后端跨域支持配置
  withCredentials: true,
  crossDomain: true
})

/**
 *添加请求拦截器
 */
req.interceptors.request.use(function (config) {
  if (localStorage.getItem('token')) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
/**
 * 添加响应拦截器
 */
req.interceptors.response.use(res => {
  if (res.data.code) {
    Message({
      type: 'warning',
      message: res.data.msg || '网络异常',
      duration: 3000
    })
    const error = res.data
    return Promise.reject(error)
  } else {
    return Promise.resolve(res.data)
  }
}, err => {
  let message = '网络异常'
  if (err.response && err.response.data) message = err.response.data.msg
  Message({
    type: 'error',
    message: message || '网络异常',
    duration: 3000
  })
  return Promise.reject(err)
})

export default req



// WEBPACK FOOTER //
// ./src/utils/http.js